
export const NOTIFICATIONS = ["NOTIFICATIONS"];